import { PurchaseOrderDto } from "./useGetPurchaseOrders";
import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";
import { HttpMethod } from "../../Common/useFetch";
import useUserRequest, { UserRequestSpec } from "../../Common/useUserRequest";
import { RequestOptions } from "../../Common/useRequest";

export type PoUpsertDto = Omit<PurchaseOrderDto, 'id' | 'supplierName' | 'productName' | 'siteName' | 'hasTransactions'>;

const path = (businessId: string) => `/api/businesses/${businessId}/purchaseOrders`;

const createSpec = (businessId: string): UserRequestSpec => ({
  path: path(businessId),
  method: HttpMethod.POST,
});

const updateSpec = (businessId: string, poId: string): UserRequestSpec => ({
  path: `${path(businessId)}/${poId}`,
  method: HttpMethod.PUT,
});

const useUpsertPurchaseOrder = (poId?: string, options?: RequestOptions<string>) => {
  const business = useSelectedBusiness();

  var spec = poId
    ? updateSpec(business.id, poId)
    : createSpec(business.id);

  return useUserRequest<PoUpsertDto, string>(spec, options);
}

export default useUpsertPurchaseOrder;
